import {
  type BaseHovercardOptions,
  type HovercardAttributesResult,
  buildHovercardAttributes,
  useHovercardAttributesBase,
} from './shared'

export type TrackedInHovercardOptions = BaseHovercardOptions & {
  /** The hovercard URL for the tracked_in relationship */
  url: string | null | undefined
}

/**
 * Generate hovercard attributes for a tracked_in relationship.
 */
function trackedInHovercardAttributes(options: TrackedInHovercardOptions): HovercardAttributesResult {
  if (!options.url) return {}

  return buildHovercardAttributes(options.url, 'tracked_in', options.tracking ?? true)
}

/**
 * React hook for tracked_in hovercard attributes.
 *
 * @example
 * ```tsx
 * function TrackedByLink({ url }: { url: string }) {
 *   const hovercardAttrs = useHovercardAttributesForTrackedIn({url: `${url}/tracked_in/hovercard/`})
 *   return <span {...hovercardAttrs}>Listed in</span>
 * }
 * ```
 */
export function useHovercardAttributesForTrackedIn(options: TrackedInHovercardOptions): HovercardAttributesResult {
  return useHovercardAttributesBase(trackedInHovercardAttributes(options))
}
